import {LoadingButtonProps} from '@mui/lab/LoadingButton'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import RealodIconSmallChangeColor from '../../images/ReloadIconGreenSmall'
import {ReloadButtonCustom} from './AppReloadButtonBase'

type AppReloadButtonProps = {
  loading: boolean
  onClick: () => void
  size?: number
  sx?: LoadingButtonProps['sx']
  LoadingButtonProps?: LoadingButtonProps
}

function AppReloadButton({onClick}: AppReloadButtonProps) {
  const {styledTheme} = usePersonalizedThemeByCompany()
  return (
    <ReloadButtonCustom onClick={onClick}>
      <RealodIconSmallChangeColor color={styledTheme.colors.primary} />
    </ReloadButtonCustom>
  )
}

export default AppReloadButton
